<section *ngIf="generating" class="no-print" role="status">
  Generating...close when complete.
</section>
<section class="p-b-16">
  <div class="flex flex-row flex-wrap gap-4 mt-4 no-print">
    <button type="button" mat-stroked-button color="primary" onclick="printJS({ printable: 'paymentSlip', type: 'html' })">
      Print Form
   </button>

    <button type="button" mat-stroked-button color="primary" (click)="pdf.saveAs('remittance.pdf')">
      Export to PDF
    </button>

    <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
  </div>
</section>
  <mat-dialog-content>
    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.75" margin="1cm">
      <div class="pdf-document flex flex-col gap-4 f-s-16" id="paymentSlip" #paymentSlip>

        <div class="grid grid-cols-2">
          <div class="flex flex-col">
            <span class="f-s-18"><strong>PUBLIC HEALTH DIVISION</strong></span>
            <span class="f-s-18"><strong>CENTER FOR HEALTH PROTECTION</strong></span>
            <span><strong>HFLC</strong></span>
            <span><a href="http://oregon.gov/">http://oregon.gov/</a></span>
          </div>
          <div class="justify-self-end">
            <img class="p-4" src="../../../../../assets/images/OHA-Color.png" alt="OHA Logo">
          </div>
        </div>

        <div class="flex flex-row justify-center">
          <span class="f-s-18"><strong>{{pageTitle}} </strong></span>
        </div>

        <div class="flex flex-col gap-2" *ngIf="showIndiviudalLicense">
          <div class="flex flex-row">
            <span class="w-1/3"><strong>Name</strong></span>
            <span>{{licenseName}}</span>
          </div>
          <div class="flex flex-row">
            <span class="w-1/3"><strong>Responsible Party(RP) Name</strong></span>
            <span>{{responsiblePartyName}} </span>
          </div>
          <div class="flex flex-row">
            <span class="w-1/3"><strong>RP Phone Number</strong></span>
            <span>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</span>
          </div>
          <div class="flex flex-row">
            <span class="w-1/3"><strong>RP Email</strong></span>
            <span>{{responsiblePartyEmail}}</span>
          </div>
          <div class="flex flex-row">
            <span class="w-1/3"><strong>Application ID Number (if known)</strong></span>
            <span>{{licenseId}}</span>
          </div>
          <div class="flex flex-row">
            <span class="w-1/3"><strong>Application Date</strong></span>
            <span>{{applicationDate}}</span>
          </div>
        </div>

        <div class="flex flex-col gap-2" *ngIf="!showIndiviudalLicense">
          <div class="flex flex-col gap-2" *ngIf="!isEntityLicense">
            <div class="flex flex-row">
              <span class="w-1/3"><strong>{{individualType}}Name</strong></span>
              <span>{{responsiblePartyName}} </span>
            </div>
            <div class="flex flex-row">
              <span class="w-1/3"><strong>{{individualType}} Phone Number</strong></span>
              <span>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</span>
            </div>
            <div class="flex flex-row">
              <span class="w-1/3"><strong>{{individualType}} Email</strong></span>
              <span>{{responsiblePartyEmail}}</span>
            </div>
          </div>

          <div class="flex flex-col gap-2" *ngIf="isEntityLicense">
            <div class="flex flex-row">
              <span class="w-1/3"><strong>Agency Name</strong></span>
              <span>{{licenseName}}</span>
            </div>
            <div *ngIf="data.entityType !== sharedService.hospitalLicense">
              <div class="flex flex-row">
                <span class="w-1/3"><strong>Point of Contact Name</strong></span>
                <span>{{responsiblePartyName}} </span>
              </div>
              <div class="flex flex-row">
                <span class="w-1/3"><strong>Point of Contact Phone</strong></span>
                <span>{{responsiblePartyPhone | mask:'(000)-000-0000 000000'}}</span>
              </div>
              <div class="flex flex-row">
                <span class="w-1/3"><strong>Point of Contact Email</strong></span>
                <span>{{responsiblePartyEmail}}</span>
              </div>
            </div>

          </div>

          <div class="flex flex-row">
            <span class="w-1/3"><strong>HFLC ID Number</strong></span>
            <span>{{licenseId}}</span>
          </div>
          <div class="flex flex-row" *ngIf="data.entityType !== sharedService.hospitalLicense">
            <span class="w-1/3"><strong>Application Date</strong></span>
            <span>{{applicationDate}}</span>
          </div>
        </div>

        <div class="flex flex-row gap-2 justify-center">
          <div class="flex flex-col gap-2 justify-start items-center w-1/2">
            <span><strong>Type of Payment</strong></span>
            <mat-radio-group class="flex flex-col" aria-label="Type of payment">
              <mat-radio-button value="1" class="radio-button">Cashier's Check</mat-radio-button>
              <mat-radio-button value="2" class="radio-button">Money Order</mat-radio-button>
              <mat-radio-button value="3" class="radio-button">Personal/Business Check</mat-radio-button>
              <mat-radio-button value="4" class="radio-button">Cash <strong>(Please Do Not Mail Cash Payments)</strong>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="flex flex-col gap-2 justify-start items-center w-1/2">
            <span><strong>Payment Purpose</strong></span>
            <div>
              <mat-radio-group class="flex flex-col" aria-label="Payment purpose">
                <!--Licenses-->
                <div class="flex flex-col">
                  <mat-radio-button value="5" class="radio-button" *ngIf="application">New Application Fee ${{ formatAmount(fee) }}</mat-radio-button>
                  <mat-radio-button value="6" class="radio-button" *ngIf="renewal">License Renewal Fee ${{ formatAmount(fee) }}</mat-radio-button>
                  <mat-radio-button value="8" class="radio-button" *ngIf="change">License Change Fee ${{ formatAmount(fee) }}</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>

        <div class="flex flex-row justify-center items-start">
          <strong>Instructions for Submitting the Application and Fee Payment by Mail or In-Person</strong>
        </div>

        <div class="flex flex-col">
          <span>Money orders and checks are payable to: <strong>OHA</strong></span>
          <span>
            Personal and business checks will be held for 21 days to ensure payment clearance.
            Applications will be reviewed once payment has been cleared.
          </span>
        </div>

        <div class="flex flex-col">
          <span><strong>Mailing the application packet, money order or check, and remittance form:</strong></span>
          <span>
            Oregon Health Authority - Public Health Division - Fiscal Services
          </span>
          <span>
            RE: HFLC, PO Box 14260, Portland, OR 97293-0260
          </span>
        </div>

        <div class="flex flex-col">
          <span><strong>In-person payment with a money order or check:</strong></span>
          <span>
            To make an in-person fee payment with a money order or check, proceed to Cashier's Office on the
            second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200, Portland, OR 97232 - Hours:
            9am to 4pm, Mon to Fri
          </span>
        </div>

        <span>
          Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health
          Statistics window.
          If security asks if you have an appointment, you may let them know you are dropping off a payment for Business
          at the
          Cashier's Office window which does not require an appointment. Please include the remittance form with the
          payment and provide the application,
          if not already submitted by mail.
        </span>

        <div class="flex flex-col">
          <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
          <div class="flex flex-row gap-2 justify-start items-center">
            <span>{{getEmail()}}</span>
            <span>or {{getPhone()}}</span>
          </div>
        </div>

        <span *ngIf="application"><strong>{{applicationSlipReference}}</strong></span>
        <span *ngIf="renewal"><strong>{{annualSlipReference}}</strong></span>

      </div>
    </kendo-pdf-export>
  </mat-dialog-content>
